/**
 * Pre-compiled pt-BR messages for LocalizedField
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  hideCurrencies: `Ocultar todas as ocorrências`,
  hideLanguages: `Ocultar todos os idiomas`,
  infoBoxTriggerAriaLabel: `mais informações`,
  missingRequiredField: `Este campo é obrigatório. Forneça pelo menos um valor.`,
  showCurrencies: `Mostrar todas as ocorrências`,
  showLanguages: `Mostrar todos os idiomas`,
};
